import { useCallback, useState } from 'react';
import { useAppDispatch } from './useAppDispatch';
import { setSearchMetaTooltipAvailable } from 'shared/slices/searchMetaTooltip';

export const useModalState = () => {
  const dispatch = useAppDispatch();

  const [modalOpened, setModalOpened] = useState(false);

  const onOpen = useCallback(() => {
    setModalOpened(true);
    dispatch(setSearchMetaTooltipAvailable(false));
  }, [dispatch]);

  const onClose = useCallback(() => {
    setModalOpened(false);
    dispatch(setSearchMetaTooltipAvailable(true));
  }, [dispatch]);

  return { opened: modalOpened, onOpen, onClose };
};
